import {login, logout, getInfo, modifyAvatar, autoLogin, registerUser, unBindUser} from '@/api/authority'
import {auth} from '@bestvike/utils'
import {resetRouter} from '@/router'
import Cookies from 'js-cookie'

const state = {
	token: auth.getToken(),
	name: '',
	avatar: '',
	introduction: '',
	roles: [],
	refreshPromise: '',
	weixinId: Cookies.get('X-WeixinId'),
	unionId: Cookies.get('X-UnionId')     // 【新增】开放平台 unionid（全局唯一）
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_INTRODUCTION: (state, introduction) => {
		state.introduction = introduction
	},
	SET_NAME: (state, name) => {
		state.name = name
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	},
	SET_REFRESH_PROMISE: (state, refreshPromise) => {
		state.refreshPromise = refreshPromise
	},
	SET_WEIXINID: (state, weixinId) => {
		console.log("X-WeixinId===:"+weixinId)
		state.weixinId = weixinId;
		Cookies.set('X-WeixinId', weixinId);
	},
	// 【新增】微信 unionid（全局唯一）
	SET_UNIONID: (state, unionId) => {
		console.log("X-UnionId===:"+unionId)
		state.unionId = unionId;
		Cookies.set('X-UnionId', unionId);
	}
}

const actions = {
	// user login 用户名/密码
	login({commit}, userInfo) {
		const {id, password} = userInfo
		return new Promise((resolve, reject) => {
			login({id: id.trim(), password: password}).then(response => {
				const {data} = response
				commit('SET_TOKEN', data.token)
				auth.setToken(data.token)
				auth.setRefreshToken(data.refreshToken)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// user login weixinId
	autoLogin({commit}, loginInfo) {
		let weixinId = null;
		let unionId = null;

		// 支持对象格式 { weixinId, unionId }
		if (typeof loginInfo === 'object') {
			weixinId = loginInfo.weixinId;
			unionId = loginInfo.unionId;
		} else {
			// 兼容旧格式：字符串
			weixinId = loginInfo;
		}

		// ==============================================
		// 传给后端的 ID：优先 unionId，没有再用 weixinId
		// ==============================================
		let finalLoginId = unionId || weixinId;

		// 保存到 vuex + cookie
		if (weixinId) {
			commit('SET_WEIXINID', weixinId);
		}
		if (unionId) {
			commit('SET_UNIONID', unionId);
		}

		return new Promise((resolve, reject) => {
			// ==============================
			// 传给后端：finalLoginId（unionId优先）
			// ==============================
			autoLogin(finalLoginId).then(response => {
				const {data} = response
				if (data) {
					commit('SET_TOKEN', data.token)
					auth.setToken(data.token)
					auth.setRefreshToken(data.refreshToken)
						resolve(data.token)
				}
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	registerUser({commit, state}, userInfo) {
		// 最终传给后端的 ID：优先 unionId
		const finalId = state.unionId || state.weixinId;

		userInfo.weixinId = finalId;
		userInfo.unionId = state.unionId;

		return new Promise((resolve, reject) => {
			registerUser(userInfo).then(response => {
				const {data} = response
				if (data) {
					commit('SET_TOKEN', data.token)
					auth.setToken(data.token)
					auth.setRefreshToken(data.refreshToken)
					// 注册成功后，把 finalId 存到 weixinId
					commit('SET_WEIXINID', finalId);

					resolve()
				}
			}).catch(error => {
				reject(error)
			})
		})
	},

	unBindUser({commit}) {
		return new Promise((resolve, reject) => {
			unBindUser().then(response => {
				const {data} = response;
				if (data) {
					commit('SET_TOKEN', '');
					commit('SET_ROLES', []);
					auth.removeToken();
					auth.removeRefreshToken();
					resolve()
				}
			}).catch(error => {
				reject(error)
			})
		})
	},

	refreshToken({commit}, token) {
		commit('SET_TOKEN', token)
		auth.setToken(token)
	},

	// 获取用户信息
	getInfo({commit, state}) {
		return new Promise((resolve, reject) => {
			getInfo(state.token).then(response => {
				const {data} = response

				if (!data) {
					reject('Verification failed, please Login again.')
				}

				const {roles, name, avatar, introduction} = data

				// roles must be a non-empty array
				if (!roles || roles.length <= 0) {
					reject('getInfo: roles must be a non-null array!')
				}

				commit('SET_ROLES', roles)
				commit('SET_NAME', name)
				commit('SET_AVATAR', avatar)
				commit('SET_INTRODUCTION', introduction)

				resolve(data)
			}).catch(error => {
				reject(error)
			})
		})
	},

	// 登出
	logout({commit, state}) {
		return new Promise((resolve, reject) => {
			logout(state.token).then(() => {
				commit('SET_TOKEN', '')
				commit('SET_ROLES', [])
				auth.removeToken()
				auth.removeRefreshToken()
				resetRouter()
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// remove token
	resetToken({commit}, token) {
		return new Promise(resolve => {
			if (!token) {
				commit('SET_TOKEN', '')
				auth.removeToken()
			} else {
				commit('SET_TOKEN', token)
				auth.setToken(token)
			}
			resolve()
		})
	},

	// 设置头像
	setAvatar({commit}, avatar) {
		modifyAvatar(avatar).then(() => {
			commit('SET_AVATAR', avatar)
		})
	},

	// 设置刷新token
	setRefreshPromise({commit}, refreshPromise) {
		commit('SET_REFRESH_PROMISE', refreshPromise)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
